import React from 'react';
import ComponentHelper from '../../supers/ComponentHelper';
import './multi-toggle.css';

class MultiToggle extends ComponentHelper {
	onOptionClick = evt => {
		let val = evt.target.dataset.value;
		if (val) {
			this.props.onChange(val);
		}
	};
	render() {
		let options = [];
		for (let i = 0; i < this.props.options.length; i++) {
			let opt = this.props.options[i];
			options.push(
				<div
					className={`tgl-option vbox vcenter hcenter ${this.props.active === opt.value ? 'active' : ''}`}
					data-value={opt.value}
					key={opt.value + 'multi-toggle-key'}
					onClick={this.onOptionClick}
				>
					{opt.label}
				</div>
			);
		}
		return <div className={`multi-toggle-cmp hbox vcenter ${this.props.className}`}>{options}</div>;
	}
}

export default MultiToggle;



// WEBPACK FOOTER //
// ./src/components/multi-toggle/MultiToggle.js